module.exports = __webpack_public_path__ + "media/cold-sun-del-no-copyright-music.49ef280b.mp3";